{/* Auto-generated icon - do not edit */}
import React from 'react'

interface RecordIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const RecordIcon = React.forwardRef<SVGSVGElement, RecordIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 121 107"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<g clip-path="url(#clip0)">
<path d="M62.0749 106.786C47.354 106.474 33.4895 103.256 21.1549 95.1194C9.6036 87.4966 2.3775 76.9578 1.30403 63.0243C0.525924 52.4081 2.64792 41.7803 7.44816 32.2521C10.3771 26.2788 13.9451 20.6948 18.6799 15.9133C28.2538 6.24464 39.9793 1.33938 53.5536 0.507872C62.8693 -0.063869 72.0654 0.32157 80.933 3.61407C88.4812 6.35216 95.5893 10.1536 102.037 14.9007C113.174 23.2016 119.678 34.0156 120.363 47.9482C121.128 63.4677 116.956 77.3458 106.298 89.0888C97.8067 98.4435 87.0588 103.551 74.7145 105.575C70.5484 106.255 66.291 106.396 62.0749 106.786ZM62.7493 96.785C64.4358 96.6915 67.3495 96.6787 70.2249 96.3454C81.0934 95.0878 90.6517 91.1772 98.0727 82.8615C107.677 72.097 110.41 59.472 108.634 45.5884C107.753 38.2645 104.064 31.5536 98.3258 26.8376C80.331 11.6456 59.8477 7.39907 37.0914 13.7527C36.4842 14.0217 35.8361 14.1896 35.1734 14.2496C33.421 14.1085 32.2066 15.0393 30.9995 16.0313C29.7923 17.0233 28.5629 17.9734 27.4582 19.0569C18.1893 27.9961 12.4316 39.8968 11.2106 52.6394C10.5701 58.6572 10.394 64.7765 12.7836 70.5887C15.8705 78.1167 21.4398 84.393 28.5884 88.3997C38.7525 94.3195 49.8479 96.6903 62.7493 96.785Z" fill={color}/>
<path d="M60.883 30.7021C67.3531 30.6757 71.9594 32.9324 75.4727 37.4154C75.9449 38.029 76.4484 38.618 76.9812 39.1803C82.9923 45.3966 84.2529 52.6848 81.4544 60.5873C75.324 77.9062 55.5371 82.3093 42.3443 72.785C35.4019 67.7728 32.702 60.8407 34.5144 52.4483C37.1804 40.1014 50.6126 30.2715 60.883 30.7021Z" fill={color}/>
</g>
<defs>
<clipPath id="clip0">
<rect width="120" height="107" fill={color} transform="translate(0.777344)"/>
</clipPath>
</defs>

      </svg>
    )
  }
)

RecordIcon.displayName = 'RecordIcon'
